export default __webpack_public_path__ + "3a3993e6baa891fd9258822415be5859.png";